import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getDescription } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import DescriptionView from './view.tsx';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	description: getDescription(state, ownProps.componentId),
});

export default connect(mapStateToProps, {})(DescriptionView);
